export const EMAIL_VERIFICATION_COPY: Record<string, string> = {
  signup: 'Account created! Please click the temporary activation link we sent to your email.',
  existingUser: 'Please click the temporary account activation link we sent to your email.',
  locgSignup:
    "To access your account, please click the activation link sent to your email from Team Flowcode. Didn't get an email? Please check your spam folder or <activationLink>click here</activationLink> to send it again."
}
